import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("gd_admin_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "No se pudo iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-void px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-line bg-ink p-8 sm:p-10">
        <div className="flex items-baseline gap-2">
          <span className="font-display text-xs font-bold tracking-[0.35em] text-slate-100">GRUPO</span>
          <span className="text-gold-gradient font-serif text-2xl font-bold">Disimil</span>
        </div>
        <h1 className="mt-8 font-serif text-2xl font-semibold text-slate-100">Área de Facturación</h1>
        <p className="mt-2 text-sm font-light text-slate-400">
          Acceso privado. Ingresa tus credenciales de administrador.
        </p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">
              Usuario
            </label>
            <input
              type="text"
              required
              autoComplete="username"
              placeholder="Tu usuario"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="mt-2 w-full border border-line bg-void px-4 py-3 text-sm text-slate-200 focus:border-gold/50 focus:outline-none"
            />
          </div>
          <div>
            <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">
              Contraseña
            </label>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="mt-2 w-full border border-line bg-void px-4 py-3 text-sm text-slate-200 focus:border-gold/50 focus:outline-none"
            />
          </div>
          {error && (
            <p
              className="border border-red-900/50 bg-red-950/40 px-4 py-3 text-sm text-red-300"
              data-testid="admin-login-error"
            >
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="flex w-full items-center justify-center gap-3 bg-gold px-6 py-4 font-mono text-xs uppercase tracking-[0.24em] text-void transition-opacity hover:opacity-90 disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
            Entrar
          </button>
        </form>

        <Link
          to="/"
          className="mt-6 block text-center font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 transition-colors hover:text-gold"
        >
          Volver al sitio
        </Link>
      </div>
    </main>
  );
}
